import * as types from './types'

export const clearResources = () => ({
  type: types.CLEAR_RESOURCES,
})
